var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    enableBackground: "new 0 0 96 96",
    height: 512,
    viewBox: "0 0 96 96",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Product_Package",
    d: "m90.895 25.211-42-21c-.563-.281-1.227-.281-1.789 0l-42 21c-.678.339-1.106 1.031-1.106 1.789v42c0 .758.428 1.45 1.105 1.789l42 21c.282.141.588.211.895.211s.613-.07.895-.211l42-21c.677-.339 1.105-1.031 1.105-1.789v-42c0-.758-.428-1.45-1.105-1.789zm-42.895-16.975 37.528 18.764-8.028 4.014-37.527-18.764zm13.5 30.778-37.528-18.764 11.528-5.764 37.528 18.764zm1.5 3.722 12-6v14.877l-3.838-2.741c-.435-.311-.979-.434-1.506-.343-.527.093-.996.392-1.301.832l-5.355 7.737zm-43.5-20.25 37.527 18.764-9.027 4.514-37.528-18.764zm-11.5 7.75 38 19v37.527l-38-19zm42 56.528v-37.528l9-4.5v18.764c0 .875.568 1.648 1.403 1.909.198.062.398.091.597.091.644 0 1.264-.312 1.645-.861l7.845-11.331 5.349 3.82c.61.435 1.412.494 2.077.15.665-.342 1.084-1.029 1.084-1.778v-20.764l9-4.5v37.527z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.4e2a0db8be23d383a95f9cc4c3bedd28.svg";
export { ForwardRef as ReactComponent };